module.exports = __webpack_public_path__ + "img/banner1-1.9fd58d67.png";